import clsx from 'clsx';
import Link from 'next/link';
import { useContext } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import type { Product } from 'src/models/product/schema';
import { BrandsContext } from 'src/stores/Brands';
import { brandName } from 'src/utils/brandName';
import { comma } from 'src/utils/comma';
// TODO: 全ページへのランキングデザイン更新後にスタイルファイルを統一する
import { useRouter } from 'next/router';
import { PriceWithLocalCurrency } from 'src/components/shared/elements/text/PriceWithLocalCurrency';
import { BuyerCommentLabel } from 'src/components/shared/products/BuyerCommentLabel';
import { RatingStars } from 'src/components/shared/products/RatingStars';
import { CategoryContext } from 'src/stores/Category';
import type { LOCALE_TYPE } from 'src/types/locale';
import { isLocaleEn } from 'src/utils/locale';
import { isDrugProduct } from 'src/utils/productHelper';
import newStyles from './index.module.scss';
import oldStyles from './old.module.scss';

type Props = {
  product: Product;
  index: number;
  useNewStyles?: boolean; // 新or旧デザインをpropsで判定する
  onClick?: () => void;
  hideIndex?: boolean;
};

export const RankingItem: React.FC<Props> = ({ product, index, useNewStyles, onClick, hideIndex }) => {
  const { locale } = useRouter();
  const brands = useContext(BrandsContext);
  const category = useContext(CategoryContext);
  const isEn = isLocaleEn(locale as LOCALE_TYPE);
  const styles = useNewStyles ? newStyles : oldStyles;

  const rankingStyles = () => {
    switch (index + 1) {
      case 1:
        return styles.first;
      case 2:
        return styles.second;
      case 3:
        return styles.third;
      case 100:
        return styles.hundred;
      default:
        return;
    }
  };

  return (
    <Link href={`/products/${product.productId}`}>
      <a aria-label={product.name} onClick={onClick}>
        <div className={styles.container}>
          <div className={styles.imageWrapper}>
            {!hideIndex && <div className={clsx(styles.ranking, rankingStyles())}>{index + 1}</div>}
            <div className={styles.image}>
              <NextImage
                src={product.images[0]}
                width={300}
                height={300}
                layout="responsive"
                objectFit="contain"
                alt={product.name}
              />
              {product.buyerComment && <BuyerCommentLabel isSmall />}
            </div>
          </div>
          <div className={styles.content}>
            <div>
              <div className={styles.textContainer}>
                <span className={styles.brand}>{brandName(product, brands)}</span>
                <span className={styles.name}>{product.name}</span>
              </div>
              {!isDrugProduct(product, category) && (
                <RatingStars rating={product.reviewRatingAverage} count={product.reviewCount} withRating />
              )}
            </div>
            <div className={styles.price}>
              <PriceWithLocalCurrency currency={product.currencySymbol} price={product.exchangeRateAdjustedPrice} />
              <div className={styles.local}>
                JPY
                {comma(product.undiscountedPrice)}
              </div>
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};
